import ApplicationController from './application'

export default class extends ApplicationController {
  static targets = ['row', 'selectAll', 'actions', 'count']

  connect() {
    this.sync()
  }

  toggleAll() {
    const checked = this.selectAllTarget.checked
    this.rowTargets.forEach((checkbox) => { checkbox.checked = checked })
    this.sync()
  }

  sync() {
    const selected = this.rowTargets.filter((checkbox) => checkbox.checked).length
    const any = selected > 0
    const all = this.rowTargets.length > 0 && selected === this.rowTargets.length

    if (this.hasCountTarget) this.countTarget.textContent = selected

    if (this.hasSelectAllTarget) {
      this.selectAllTarget.checked = all
      this.selectAllTarget.indeterminate = any && !all
    }

    if (this.hasActionsTarget) {
      this.actionsTarget.classList.toggle('hidden', !any)
    }
  }
}
